import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarService } from '@app/shared/services/navbar.service';
import { TranslateService } from '@ngx-translate/core';
import { ICompanySetting } from '@shared/interfaces/company-setting.interface';
import { IEvent } from '@shared/interfaces/event.interface';
import { IPayload } from '@shared/interfaces/payload.interface';
import { CompaniesService } from '@shared/services/companies.service';
import { CompanySettingsService } from '@shared/services/company-settings.service';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationEventsService } from '@shared/services/pagination/pagination.events.service';
import jwtDecode from 'jwt-decode';
import { LocalStorage } from 'ngx-webstorage';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  @LocalStorage() private companySettings: ICompanySetting;

  public settingsSubscription: Subscription;
  public settings: ICompanySetting;

  public isProduction = Boolean(this._commonEnvironments.IS_PRODUCTION);
  public isCollapsed = Boolean(true);
  public isAdmin = Boolean(false);
  public isTenant = Boolean(false);
  public isVendor = Boolean(false);
  public isAnalytics = Boolean(false);
  public isManager = Boolean(false);
  public isEmployee = Boolean(false);
  public isExpanded = Boolean(true);
  

  public companyLogo: string;

  public logo = String(
    `../../../../assets/images/logo_onsitehq.png`
  );
  public logoMenu = String(
    `../../../../assets/images/logo_onsite_white.png`
  );
  public logoWhiteMenu = String(
    `../../../../assets/images/logo_white.png`
  );

  public openEventsModal: Subject<IEvent> = new Subject();

  public params: any = {
    environment: this._commonEnvironments.ENVIRONMENT
  };

  public links: {
    id: number;
    isEnabled: boolean;
    items: {
      label: string;
      icon: string;
      url: string;
      isEnabled: boolean;
      order: number;
    }[];
  }[] = [];


  private readonly constructorName: string = String(this.constructor.name);
  constructor(
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _navbar: NavbarService,
    private readonly _router: Router,
    private readonly _paginationEvents: PaginationEventsService,
    private readonly _companies: CompaniesService,
    private readonly _logger: LoggerService

  ) {
    this.afterSubmit = this.afterSubmit.bind(this);

    this.settingsSubscription = this._navbar
      .getCompanySettings()
      .subscribe((res: { label: string; value: string }) => {
        const label = res.label;
        debugger

        switch (label) {
          // ATS
          case 'isQrCodeEnabled':
            if (res.value) {
              const isQrCodeEnabled = this.links[1].items.find(
                (l: any) => l.label === 'NAVBAR.LINKS.QR_CODES'
              );

              if (!isQrCodeEnabled) {
                this.setQRCodesLink();
              }
            } else if (!this.companySettings.isQrCodeEnabled) {
              this.links[1].items = this.links[1].items.filter(
                (l: any) => l.label !== 'NAVBAR.LINKS.QR_CODES'
              );
            }
            break;
          case 'isReportEnabled':
        }

        this.sortItems();
      });
  }

  ngOnInit(): void {
    const payload: IPayload = jwtDecode(this._commonEnvironments.getToken());

    this.isAdmin = Boolean(payload.employeeRole === 0);
    this.isManager = Boolean(payload.employeeRole === 1);
    this.isAnalytics = Boolean(payload.employeeRole === 2);
    this.isEmployee = Boolean(payload.employeeRole === 3);
    this.isVendor = Boolean(payload.role === 4);
    this.isTenant = Boolean(payload.role === 5);
    this.settings = this.companySettings;
    this.setLinks();
    this.getCompanyLogo();
  }

  ngOnDestroy(): void {
    this.settingsSubscription?.unsubscribe();
  }

  public trackByFn(i): string {
    return i.id;
  }

  public openModal() {
    this.openEventsModal.next();
  }

  public afterSubmit(e: IEvent) {
    this._paginationEvents.reloadPage(1);
    this._router.navigate(['/events', e.id]);
  }

  public getCompanyLogo() {
    const id = JSON.parse(localStorage.getItem('app.onsitehq.co|companysettings'))?.company.id
    const url = `GET /companies/${id}/logo`;
    this._companies.getLogo(id).subscribe(
      (response: any) => {
        this._logger.info(this.constructorName, url, response);
        this.companyLogo = response.logo;
      },
      (err: any) => {
        this._logger.error(this.constructorName, url, err);
      }
    );
  }



  public expandContent() {
    if (this.isExpanded) {
      document.getElementById('protected-content').classList.add('expand-content');
    } else {
      document.getElementById('protected-content').classList.remove('expand-content');
    }
    this.isExpanded = !this.isExpanded;
  }

  private setLinks() {
    if (this.isTenant) {
      this.links = [
        {
          id: 0,
          isEnabled: true,
          items: [
            {
              label: 'NAVBAR.LINKS.TASKS',
              icon: 'lnr-warning',
              url: '/tasks',
              isEnabled: true,
              order: 4
            },
            {
              label: 'NAVBAR.LINKS.LIBRARIES',
              url: '/documents',
              icon: 'lnr-cloud-upload',
              isEnabled: true,
              order: 5
            }
          ]
        }
      ];
    } else if (this.isVendor) {
      this.links = [
        {
          id: 0,
          isEnabled: true,
          items: [
            {
              label: 'NAVBAR.LINKS.DASHBOARD',
              icon: 'lnr-chart-bars',
              url: '/dashboard/events',
              isEnabled: true,
              order: 0
            },
            {
              label: 'NAVBAR.LINKS.THREADS',
              url: '/threads',
              icon: 'lnr-envelope',
              isEnabled: true,
              order: 1
            },
            {
              label: 'NAVBAR.LINKS.TASKS',
              icon: 'lnr-warning',
              url: '/tasks',
              isEnabled: true,
              order: 5
            },
            {
              label: 'NAVBAR.LINKS.ASSETS',
              url: '/assets',
              icon: 'lnr-pie-chart',
              isEnabled: true,
              order: 7
            },
            {
              label: 'NAVBAR.LINKS.LIBRARIES',
              url: '/documents',
              icon: 'lnr-cloud-upload',
              isEnabled: true,
              order: 5
            },
          ]
        },
        
      ];
    } else {
      this.links = [
        {
          id: 0,
          isEnabled: true,
          items: [
            {
              label: 'NAVBAR.LINKS.DASHBOARD',
              icon: 'lnr-chart-bars',
              url: '/dashboard/events',
              isEnabled: true,
              order: 0
            },
            // {
            //   label: 'NAVBAR.LINKS.THREADS',
            //   url: '/threads',
            //   icon: 'lnr-envelope',
            //   isEnabled: true,
            //   order: 1
            // },
            // {
            //   label: 'NAVBAR.LINKS.INSPECTIONS',
            //   icon: 'lnr-calendar-full',
            //   url: '/events',
            //   isEnabled: true,
            //   order: 2
            // },
            {
              label: 'NAVBAR.LINKS.REPORTS',
              icon: 'lnr-chart-bars',
              url: '/reports',
              isEnabled: (this.settings.isReportEnabled ? true : false) && (this.isAdmin || this.isManager),
              order: 3
            },
            {
              label: 'NAVBAR.LINKS.CHECKLISTS',
              icon: 'lnr-clipboard-check',
              url: '/checklists',
              isEnabled: true,
              order: 4
            },
            {
              label: 'NAVBAR.LINKS.TASKS',
              icon: 'lnr-warning',
              url: '/tasks',
              isEnabled: true,
              order: 5
            },
            {
              label: 'NAVBAR.LINKS.CONTACTS',
              icon: 'lnr-contacts',
              url: '/contacts',
              isEnabled: true,
              order: 6
            },
            {
              label: 'NAVBAR.LINKS.ASSETS',
              url: '/assets',
              icon: 'lnr-pie-chart',
              isEnabled: true,
              order: 7
            },
            {
              label: 'NAVBAR.LINKS.ISSUES',
              url: '/issues',
              icon: 'lnr-cross-circle',
              isEnabled: true,
              order: 8
            },

            // {
            //   label: 'NAVBAR.LINKS.CALENDAR',
            //   url: '/calendar',
            //   icon: 'lnr-calendar-full',
            //   isEnabled: true,
            //   order: 9
            // },
            // {
            //   label: 'NAVBAR.LINKS.ACTIVITIES',
            //   icon: 'lnr-radar',
            //   url: '/activities',
            //   isEnabled: this.isManager
            // }
          ]
        },
        {
          id: 1,
          isEnabled: this.isAdmin || this.isManager,
          items: [
            {
              label: 'NAVBAR.LINKS.EMAILS',
              icon: 'lnr-envelope',
              url: '/emails',
              isEnabled: true,
              order: 1
            },
            {
              label: 'NAVBAR.LINKS.NOTIFICATIONS',
              icon: 'lnr-bullhorn',
              url: '/notifications',
              isEnabled: true,
              order: 2
            },
            {
              label: 'NAVBAR.LINKS.LOCATIONS',
              icon: 'lnr-location',
              url: '/locations',
              isEnabled: true,
              order: 3
            },
            {
              label: 'NAVBAR.LINKS.CATEGORIES',
              icon: 'lnr-tag',
              url: '/categories',
              isEnabled: true,
              order: 4
            },
            {
              label: 'NAVBAR.LINKS.TEMPLATES',
              icon: 'lnr-document2',
              url: '/templates',
              isEnabled: true,
              order: 5
            },
            {
              label: 'NAVBAR.LINKS.USERS',
              icon: 'lnr-users',
              url: '/users',
              isEnabled: true,
              order: 6
            },
            {
              label: 'NAVBAR.LINKS.LIBRARIES',
              url: '/documents',
              icon: 'lnr-cloud-upload',
              isEnabled: true,
              order: 7
            },
            {
              label: 'NAVBAR.LINKS.MARKETPLACE',
              icon: 'lnr-store',
              url: '/marketplace',
              isEnabled: this.isAdmin,
              order: 8
            },
            {
              label: 'NAVBAR.LINKS.SETTINGS',
              icon: 'lnr-cog',
              url: '/settings',
              isEnabled: this.isAdmin,
              order: 9
            },
          ]
        }
      ];
    }

    if (this.companySettings?.isQrCodeEnabled) {
      this.setQRCodesLink();
    }

    this.sortItems();
  }

  private setQRCodesLink() {
    if (!this.isTenant) {
      this.links[1].items.push({
        label: 'QR codes',
        url: '/qrcodes',
        icon: 'lnr-focus',
        isEnabled: true,
        order: 2
      });
    }
  }

  private sortItems() {
    this.links.map((l: any) => {
      l.items.sort((i, ii) => i.order - ii.order);
    });
  }
}
